import { render, staticRenderFns } from "./EmployeeGroups.vue?vue&type=template&id=383bad80&scoped=true&"
import script from "./EmployeeGroups.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroups.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeGroups.vue?vue&type=style&index=0&id=383bad80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383bad80",
  null
  
)

export default component.exports